export interface DatedEvidence {
  client_ts: string;
}

export function localDayKey(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function groupEvidenceByDay<T extends DatedEvidence>(events: readonly T[]): Array<{
  day: string;
  events: T[];
}> {
  const groups = new Map<string, T[]>();
  for (const event of events) {
    const day = localDayKey(event.client_ts);
    if (!day) continue;
    const entries = groups.get(day) ?? [];
    entries.push(event);
    groups.set(day, entries);
  }
  return [...groups.entries()]
    .sort(([left], [right]) => right.localeCompare(left))
    .map(([day, entries]) => ({
      day,
      events: entries.sort((left, right) => right.client_ts.localeCompare(left.client_ts)),
    }));
}

export function evidenceArchiveHref(input: {
  kind: 'cleaning' | 'temperature';
  targetId: string;
  clientTs: string;
}): string {
  const params = new URLSearchParams({
    kind: input.kind,
    target: input.targetId,
    date: localDayKey(input.clientTs),
  });
  return `/settings/operational-evidence?${params.toString()}`;
}
